import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export function submitForm(id) {
  const f = document.getElementById(id);
  if (f && typeof f.requestSubmit === 'function') f.requestSubmit();
  else if (f) f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
}

export function Modal({ open, onClose, title, eyebrow, children, size = 'md', footer }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  const maxWidth =
    size === 'sm' ? 'md:max-w-md' : size === 'lg' ? 'md:max-w-3xl' : size === 'xl' ? 'md:max-w-5xl' : 'md:max-w-xl';

  return createPortal(
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className={`modal-panel w-full ${maxWidth} max-h-[92vh] md:max-h-[86vh] flex flex-col`}
      >
        <header className="flex items-start justify-between gap-4 px-6 pt-5 md:pt-6 pb-4 border-b border-line">
          <div className="min-w-0">
            {eyebrow && <div className="eyebrow mb-1.5">{eyebrow}</div>}
            <h2 className="font-display text-xl md:text-2xl leading-tight text-ink truncate">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="shrink-0 h-9 w-9 -mr-2 -mt-1 rounded-full flex items-center justify-center text-ink-2 hover:text-ink hover:bg-line-soft transition"
            aria-label="Close"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M4 4L14 14M14 4L4 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            </svg>
          </button>
        </header>
        <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
        {footer && <footer className="border-t border-line px-6 py-4 flex justify-end gap-2 bg-canvas/30">{footer}</footer>}
      </div>
    </>,
    document.body,
  );
}

export function ConfirmDialog({ open, title, message, confirmLabel = 'Confirm', danger = false, onConfirm, onClose }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <button onClick={onClose} className="btn-ghost">
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm?.();
              onClose?.();
            }}
            className={danger ? 'btn-danger' : 'btn-primary'}
          >
            {confirmLabel}
          </button>
        </>
      }
    >
      <p className="text-ink-2 leading-relaxed">{message}</p>
    </Modal>
  );
}
